import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, map, timeout } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LoginPayload, LoginResponse } from '../models/user.model';
import { CookieService } from 'ngx-cookie-service';
import {
  CityParkingRegisterMemberGroupPayload,
  CityParkingVehicleLineResponse,
  CityParkingRegisterGroupByIdResponse,
  CityParkingRegisterGroupResponse,
  CityParkingAddressSelectResponse,
  ConfirmPaymentRegisterPayload,
  ParkingCardRegisterResponse,
  CityParkingCardRegisterPayload,
  RegisterRenewVehicleLineResponse,
} from '../models/register-parking';
import {
  licenseInsertList,
  MemberLineResponse,
  RegisterMemberPayload,
} from '../models/member.model';
import {
  InforProviders,
  Providers,
  InformationResponse,
  FeeType,
  StatusAPIResponse,
  Blank,
  TaxpayerInfo,
  FinanceCoupon,
  FinanceCouponPayload,
  FinanceCouponResponse,
  MasterFee,
} from '../models/information.model';
import {
  ObjectFeeResponse,
  FeeDetailsResponse,
  ClientIInfo,
  ParkingTransactionResponse,
  ParkingTransactionDetailResponse,
  ParkingCardInfoResponse,
  ParkingGateListResponse,
  ParkingTransactionPayload,
  ClosingTransaction,
} from '../models/parking.model';
import {
  CityParkingGroupInfo,
  ParkingCardStamp,
  ParkingCardSummary,
} from '../models/parking-card.model';
import {
  MyVehicleAllResponse,
  MyAddressAllResponse,
  UserVehicleResponse,
  MyMemberCard,
  InsertLicensePayload,
  InsertLicenseResponse,
} from '../models/user.model';
import {
  ActionApiResponse,
  CardAdvance,
  CardAdvancePayload,
  CardAdvanceResponse,
  CityParkingDiscountByIdResponse,
  CityParkingDiscountDetailsResponse,
  CityParkingDiscountLogResponse,
  CityParkingDiscountPayload,
  CityParkingDiscountResponse,
  CPCardType,
  ExecuteCityparkingDiscount,
} from '../models/card.model';
import {
  CardActiveGeneratePayload,
  CityParkingCardAdvanceApproveRespond,
  CityParkingCardAdvanceApprove,
  CouponPayload,
} from '../models/coupon.model';
import { SubscriptionInfo } from '../models/finance.model';
import {
  CityParkingStampListByIdResponse,
  CityParkingStampListPayload,
  CityParkingStampListResponse,
  ExecuteCityparkingStampList,
} from '../models/stamp.model';
import { ApiMethodService } from '../../tools/services/api/method-api/apiMethod.service';

import {
  ApiResponseManualPlateCorrection,
  EvChargerHistory,
  TransactionEVDto,
  ParkingTransactionEVDto,
  GenerateEvQrResponse,
  GenerateEvQrPayload,
  ParkingSiteEvList,
  EvDetailByIdPayload,
  EvDetailsResponse,
  EvMemberActionLogRow,
  EvShareVehicleByPlate,
} from '../models/ev.model';
import { SendManualPlateCorrectionPayload } from '../models/ev.model';
import { MenuGroup } from '../models/menu.model';
import { ApiHandlerService } from '../../tools/services/api/handler-api/apiHandler.service';
import {
  CityParkingUserInfomationResponse,
  CityParkingUserLineResponse,
  CityParkingUserProfilePayload,
  CityParkingUserProfileResponse,
  CityParkingUserVehicleDeletePayload,
  cityParkingVehicleMasterListResponse,
} from '../models/lineOA.model';
import {
  CityParkingCustomerInfoPayload,
  CityParkingCustomerInfoResponse,
  CityParkingCustomerProfileResponse,
  CityParkingCustomerLinesResponse,
  CityParkingCustomerLineDeletePayload,
  CityParkingCustomerAddressPayload,
  CityParkingLineListForChooseResponse,
  AddLineMemberCustomerPayload,
} from '../models/customer.model';
import {
  AddVehicleResponse,
  CityParkingUserVehiclePayload,
  CityParkingVehicleAllResponse,
  PatchCorrectLicensePayload,
} from '../models/vehicle.model';
import { ActionBackOfficeResponse } from '../models/api.model';
import {
  CityParkingRevenueListResponse,
  CreateTheFinancePayload,
  FinanceInfoResponse,
} from '../models/revenue.model';
import {
  InvoiceFeeList,
  InvoiceHeader,
  InvoicePayLoad,
  InvoiceHeaderResponse,
  CancelInvoicePayload,
  UpdateInvoiceDetailsPayload,
} from '../models/invoice.model';
@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private baseUrl = `${environment.apiPrivateUrl}`;
  token = '';
  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private apiMethodService: ApiMethodService,
  ) {
    this.token = this.cookieService.get('token');
  }

  // checkLogin(): Observable<boolean> {
  //   return this.http
  //     .get<{ username: string }>(this.baseUrl + '/backoffice/me', {
  //       withCredentials: true,
  //     })
  //     .pipe(map(() => true));
  // }

  checkLogin(): Observable<boolean> {
    const token = this.cookieService.get('token'); // หรือจาก localStorage
    // console.log(token);
    return this.http
      .get<{ username: string }>(this.baseUrl + '/Auth/me', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .pipe(map(() => true));
  }

  logIn(data: LoginPayload): Observable<LoginResponse> {
    const body = data;
    console.log("Data Login : ", this.baseUrl + 'Auth/Login', data)
    return this.http.post<LoginResponse>(
      this.baseUrl + '/Auth/Login',
      body,
      { withCredentials: true },
    );
  }

  getMenuByUser(userId: number): Observable<MenuGroup[]> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    const url = `${this.baseUrl}/backoffice/getMenuByUser?userId=${userId}`;
    return this.http.get<MenuGroup[]>(url, { headers });
  }

  getMemberLine(): Observable<MemberLineResponse[]> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    const url = this.baseUrl + '/backoffice/get-userline';
    return this.http.get<MemberLineResponse[]>(url, { headers });
  }

  getMembershipPackages(site_id: number): Observable<FeeDetailsResponse[]> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    const url = `${this.baseUrl}/backoffice/GetMembershipPackages?site_id=${site_id}`;
    return this.http.get<FeeDetailsResponse[]>(url, { headers });
  }

  /** @deprecated ใช้ getMembershipPackages แทน */
  getFeeDetails(site_id: number): Observable<FeeDetailsResponse[]> {
    return this.getMembershipPackages(site_id);
  }

  getMyAddress(uid: string): Observable<MyAddressAllResponse[]> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    const url = this.baseUrl + `/backoffice/GetMyAddressAll?uid=${uid}`;
    return this.http.get<MyAddressAllResponse[]>(url, { headers });
  }

  getCarDetail(): Observable<InformationResponse> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    const url = this.baseUrl + '/backoffice/GetCarDetail';
    return this.http.get<InformationResponse>(url, { headers });
  }

  getUserVehicle(uid: string): Observable<UserVehicleResponse> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    const url = this.baseUrl + `/backoffice/GetUserVehicle?uid=${uid}`;
    return this.http.get<UserVehicleResponse>(url, { headers });
  }

  getVehicleUserAllBySite(
    uid: string,
    siteId: number,
    anotherParam?: string,
  ): Observable<MyVehicleAllResponse[]> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });

    // 👉 ใช้ HttpParams สำหรับจัดการ query string
    let params = new HttpParams()
      .set('uid', uid)
      .set('siteId', siteId.toString());

    if (anotherParam) {
      params = params.set('anotherParam', anotherParam);
    }
    const url = `${this.baseUrl}/backoffice/GetUserVehicleSite`;
    return this.http.get<MyVehicleAllResponse[]>(url, { headers, params });
  }

  getUserAllVehicle(uid: string): Observable<MyVehicleAllResponse[]> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    const url = this.baseUrl + `/backoffice/GetUserVehicleAll?uid=${uid}`;
    return this.http.get<MyVehicleAllResponse[]>(url, { headers });
  }

  RegisterMember(body: RegisterMemberPayload): Observable<StatusAPIResponse> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    return this.http.post<StatusAPIResponse>(
      this.baseUrl + '/backoffice/RegisterMemberCard',
      body,
      { headers },
    );
  }

  getAddressByTaxId(data: string): Observable<TaxpayerInfo> {
    const url = this.baseUrl + `/backoffice/Search_address_by_key?data=${data}`;
    return this.http.get<TaxpayerInfo>(url, {});
  }

  getMyMemberCard(uid: string, site_id: number): Observable<MyMemberCard[]> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    console.log(token);
    const params = new HttpParams()
      .set('uid', uid)
      .set('site_id', site_id.toString());
    return this.http.get<MyMemberCard[]>(
      this.baseUrl + '/backoffice/get-my-membercard',
      { headers, params },
    );
  }
  /* ---------------------------------------------- License Insert ------------------------------------------- */
  InsertLicense(data: InsertLicensePayload): Observable<InsertLicenseResponse> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    console.log('License sent JSON : ', JSON.stringify(data));
    return this.http.post<InsertLicenseResponse>(
      this.baseUrl + '/backoffice/InsertLicense',
      data,
      { headers },
    );
  }

  getVehicleMemberInfo(
    uid: string,
    siteId: number,
    cardCode: string,
  ): Observable<MyVehicleAllResponse[]> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });

    // 👉 ใช้ HttpParams สำหรับจัดการ query string
    let params = new HttpParams()
      .set('Uid', uid)
      .set('SiteId', siteId.toString())
      .set('CardCOde', cardCode);
    const url = `${this.baseUrl}/backoffice/GetVehicleMemberInfo`;
    return this.http.get<MyVehicleAllResponse[]>(url, { headers, params });
  }

  // getFeeDetails(): Observable<FeeDetailsResponse[]> {
  //   return this.http.get<FeeDetailsResponse[]>(
  //     this.tokenUrl + `/api/GetFeeDetails`
  //   );
  // }

  /* ---------------------------------------------- Coupon ------------------------------------------- */
  getCouponInfo(): Observable<FinanceCoupon[]> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    const url = this.baseUrl + '/backoffice/GetFinanceCoupon';
    return this.http.get<FinanceCoupon[]>(url, { headers });
  }
  getFeeMaster(): Observable<MasterFee[]> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    const url = this.baseUrl + '/backoffice/GetFeeId';
    return this.http.get<MasterFee[]>(url, { headers });
  }
  sentCouponInfo(body: FinanceCouponPayload): Observable<StatusAPIResponse> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    return this.http.post<StatusAPIResponse>(
      this.baseUrl + '/backoffice/CreateFinanceCoupon',
      body,
      { headers },
    );
  }
  /* ----- View Coupon ----- */
  getCouponViewInfo(id: number): Observable<FinanceCouponResponse> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    const url = this.baseUrl + `/backoffice/GetFinanceCouponDetail?id=${id}`;
    console.log('📨 Sent getCouponViewInfo : \n', headers, url);
    return this.http.get<FinanceCouponResponse>(url, { headers });
  }

  /* -------------------------------------------------- Vehicle-card-future ------------------------------------------ */
  getCardAdvance(
    startDate: string,
    endDate: string,
  ): Observable<CardAdvance[]> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    console.log(
      'Sent getCardAdvance startDate :',
      startDate,
      'endDate :',
      endDate,
    );
    const params = new HttpParams()
      .set('startDate', startDate)
      .set('endDate', endDate);
    return this.http.get<CardAdvance[]>(
      this.baseUrl + '/backoffice/GetCardAdvances',
      { headers, params },
    );
  }

  /* ----------------------------------------------- Vehicle-card-future details ------------------------------------------ */
  getCardAdvanceCardType(): Observable<CPCardType[]> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });

    const url = this.baseUrl + `/backoffice/GetCardType`;
    console.log('Sent getCardAdvanceCardType : ', url);
    return this.http.get<CPCardType[]>(url, {
      headers,
    });
  }

  getCardAdvanceById(id: string): Observable<CardAdvanceResponse> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    const url = this.baseUrl + `/backoffice/GetCardAdvancesById`;
    const param = new HttpParams().set('id', id);
    console.log('Sent getCardAdvanceById  :\n', headers, url, param.toString());
    return this.http.get<CardAdvanceResponse>(url, {
      headers,
      params: param,
    });
  }
  sentCardAdvanceInfo(body: CardAdvancePayload): Observable<ActionApiResponse> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    console.log('Sent sentCardAdvanceInfo : ', body);
    return this.http.post<ActionApiResponse>(
      this.baseUrl + '/backoffice/CreateCardAdvances',
      body,
      { headers },
    );
  }

  /* ------------------------------------------------ CityParkingCardAdvanceApprove-parking ------------------------------------------ */
  getCardAdvancesApprove(
    startDate: string,
    endDate: string,
  ): Observable<CityParkingCardAdvanceApprove[]> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    console.log(
      'Sent getCardAdvancesApprove startDate :',
      startDate,
      'endDate :',
      endDate,
    );
    const params = new HttpParams()
      .set('startDate', startDate)
      .set('endDate', endDate);
    return this.http.get<CityParkingCardAdvanceApprove[]>(
      this.baseUrl + '/backoffice/GetCardAdvancesApprove',
      { headers, params },
    );
  }
  /* ----------------------------------------------- CityParkingCardAdvanceApprove-parking details ------------------------------------------ */
  getCardAdvancesApproveById(
    id: string,
  ): Observable<CityParkingCardAdvanceApproveRespond> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });

    const url = this.baseUrl + `/backoffice/GetCardActivateApproveById`;
    const param = new HttpParams().set('id', id);
    console.log(
      'Sent getCardAdvancesApproveById  :\n',
      headers,
      url,
      param.toString(),
    );
    return this.http.get<CityParkingCardAdvanceApproveRespond>(url, {
      headers,
      params: param,
    });
  }
  sentGenerateCardAdvanceApproveCode(
    body: CardActiveGeneratePayload,
  ): Observable<ActionApiResponse> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    return this.http.post<ActionApiResponse>(
      this.baseUrl + '/backoffice/ExecuteCardAdvance',
      body,
      { headers },
    );
  }
  GetSubscriptionInfo(
    siteId: number,
    vehicleTypeId: number,
  ): Observable<SubscriptionInfo[]> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });

    const url = `${this.baseUrl}/backoffice/GetSubscriptionByVehicleType?vehicleTypeId=${vehicleTypeId}&siteId=${siteId}`;
    console.log('Sent GetSubscriptionInfo : \n', headers, url);
    return this.http.get<SubscriptionInfo[]>(url, { headers });
  }

  GetClientIInfo(siteId: number): Observable<ClientIInfo[]> {
    console.log('Sent GetClientIInfo siteId :', siteId);
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });

    const url = `${this.baseUrl}/backoffice/GetClientInfoBySite`;
    const params = new HttpParams().set('siteId', siteId);

    console.log('Sent GetClientIInfo : \n', headers, url, params);
    return this.http.get<ClientIInfo[]>(url, { headers, params: params });
  }

  /* ------------------------------------- Discount Card ------------------------------------- */
  getCityparkingDiscount(
    startDate: string,
    endDate: string,
  ): Observable<CityParkingDiscountResponse[]> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    console.log(
      'Sent getCityparkingDiscount startDate :',
      startDate,
      'endDate :',
      endDate,
    );
    const params = new HttpParams()
      .set('startDate', startDate)
      .set('endDate', endDate);
    const url = this.baseUrl + '/backoffice/GetCityParkingDiscount';

    console.log(
      'Sent getCityparkingDiscount : ',
      headers,
      url,
      params.toString(),
    );
    return this.http.get<CityParkingDiscountResponse[]>(url, {
      headers,
      params,
    });
  }

  /* ------------------------------------- Discount Card Details ------------------------------------- */
  getCityparkingDiscountByIdResponse(
    id: string,
  ): Observable<CityParkingDiscountByIdResponse> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    const url = this.baseUrl + '/backoffice/GetCityParkingDiscountById';
    const params = new HttpParams().set('id', id);

    console.log(
      'Sent getCityParkingDiscountById : \n',
      headers,
      url,
      params.toString(),
    );
    return this.http.get<CityParkingDiscountByIdResponse>(url, {
      headers,
      params: params,
    });
  }
  sentApiCityparkingDiscountPayload(
    body: CityParkingDiscountPayload,
  ): Observable<ActionApiResponse> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    const url = this.baseUrl + '/backoffice/CreateCityParkingDiscount';
    console.log(
      'Sent Api CityParkingDiscount Payload :',
      url,
      JSON.stringify(body),
      body,
    );
    return this.http.post<ActionApiResponse>(url, body, { headers });
  }
  sentApiExecuteCityParkingDiscount(
    body: ExecuteCityparkingDiscount,
  ): Observable<ActionApiResponse> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    const url = this.baseUrl + '/backoffice/ExecuteCityParkingDiscount';
    console.log(
      'Sent Api ExecuteCityParkingDiscount Payload :',
      url,
      JSON.stringify(body),
      body,
    );
    return this.http.post<ActionApiResponse>(url, body, { headers });
  }

  /* --------------------------------------------- Discount Active -------------------------------------------- */
  getApiCityParkingDiscountDetails(
    startDate: string,
    endDate: string,
    active: boolean,
  ): Observable<CityParkingDiscountDetailsResponse[]> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    const url = this.baseUrl + '/backoffice/GetCityParkingDiscountDetails';
    const params = new HttpParams()
      .set('startDate', startDate)
      .set('endDate', endDate)
      .set('activate', active.toString());

    console.log(
      'Sent getCityParkingDiscountDetails : \n',
      headers,
      url,
      params.toString(),
    );
    return this.http.get<CityParkingDiscountDetailsResponse[]>(url, {
      headers,
      params: params,
    });
  }

  getApiCityparkingDiscountLog(
    id: number,
  ): Observable<CityParkingDiscountLogResponse[]> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    const url = this.baseUrl + '/backoffice/GetCityParkingDiscountLog';
    const params = new HttpParams().set('id', id.toString());

    console.log(
      'Sent GetCityParkingDiscountLog : \n',
      headers,
      url,
      params.toString(),
    );
    return this.http.get<CityParkingDiscountLogResponse[]>(url, {
      headers,
      params: params,
    });
  }

  /* --------------------------------------------- Stamp Discount -------------------------------------------- */
  getCityparkingStampList(): Observable<CityParkingStampListResponse[]> {
    return this.apiMethodService.request<CityParkingStampListResponse[]>(
      '/backoffice/GetCityParkingStampList',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'GetCityParkingStampList',
        token: this.token,
        headerOnly: false,
      },
    );
  }

  /* ------------------------------------- Stamp Card Details ------------------------------------- */
  getCityparkingStampListByIdResponse(
    id: string,
  ): Observable<CityParkingStampListByIdResponse> {
    return this.apiMethodService.request<CityParkingStampListByIdResponse>(
      '/backoffice/GetCityParkingStampListById',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'GetCityParkingStampListById',
        token: this.token,
        headerOnly: false,
        params: {
          id: id,
        },
      },
    );
  }
  getApiCityparkingStampRate(siteId: number): Observable<any> {
    return this.apiMethodService.request<any>(
      '/backoffice/GetCityParkingStampRate',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'GetCityParkingStampRate',
        token: this.token,
        headerOnly: false,
        params: {
          siteId: siteId,
        },
      },
    );
  }
  sentApiCityparkingStampListPayload(
    body: CityParkingStampListPayload,
  ): Observable<ActionApiResponse> {
    return this.apiMethodService.request<ActionApiResponse>(
      '/backoffice/CreateCityParkingStampList',
      'POST',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'CreateCityParkingStampList',
        token: this.token,
        headerOnly: false,
        body: body,
      },
    );
  }
  sentApiExecuteCityParkingStampList(
    body: ExecuteCityparkingStampList,
  ): Observable<ActionApiResponse> {
    return this.apiMethodService.request<ActionApiResponse>(
      '/backoffice/ExecuteCityParkingStampList',
      'POST',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'ExecuteCityParkingStampList',
        token: this.token,
        headerOnly: false,
        body: body,
      },
    );
  }

  getParkingEVAll(
    startDate: string,
    endDate: string,
    active: boolean,
  ): Observable<ParkingTransactionEVDto[]> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    const url = this.baseUrl + '/backoffice/GetParkingEVAll';
    // const params = new HttpParams()
    // .set('startDate', startDate)
    // .set('endDate', endDate)
    // .set('activate', active.toString());

    // console.log('Sent getCityParkingDiscountDetails : \n', headers , url , params.toString());
    return this.http.get<ParkingTransactionEVDto[]>(url, {
      headers,
    });
  }

  /* --------------------------------------------- Parking transaction EV -------------------------------------------- */
  GetTransactionEV(
    startDate: string,
    endDate: string,
  ): Observable<TransactionEVDto[]> {
    const token = this.cookieService.get('token');
    // const headers = new HttpHeaders({
    //   Authorization: `Bearer ${token}`,
    //   'Content-Type': 'application/json',
    // });

    // const url = `${this.baseUrl}/backoffice/GetTransactionEV?startDate=${startDate}&endDate=${endDate}`;

    return this.apiMethodService.request<TransactionEVDto[]>(
      '/backoffice/GetTransactionEV',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'GetTransactionEV',
        token: token,
        headerOnly: false,
        params: {
          startDate: startDate,
          endDate: endDate,
        },
      },
    );
  }
  getParkingSiteEvList(): Observable<ParkingSiteEvList[]> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ParkingSiteEvList[]>(
      '/backoffice/GetParkingSiteEvList',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'GetParkingSiteEvList',
        token: token,
        headerOnly: false,
      },
    );
  }

  // -------------------- Ev Detail ------------------------
  getEvDetailById(body: EvDetailByIdPayload): Observable<EvDetailsResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<EvDetailsResponse>(
      '/backoffice/GetEvDetailsByEvId',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'GetEvDetailsByEvId',
        token: token,
        headerOnly: false,
        params: {
          EvId: body.EvId,
        },
      },
    );
  }

  getEvMemberActionLogsByEvTransactionId(
    evTransactionId: number,
  ): Observable<EvMemberActionLogRow[]> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<EvMemberActionLogRow[]>(
      '/backoffice/getEvMemberActionLogsByEvTransactionId',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'getEvMemberActionLogsByEvTransactionId',
        token,
        headerOnly: false,
        params: { evTransactionId },
      },
    );
  }

  getShareVehicleByPlate(licensePlate: string): Observable<EvShareVehicleByPlate> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<EvShareVehicleByPlate>(
      '/backoffice/getShareVehicleByPlate',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'getShareVehicleByPlate',
        token,
        headerOnly: false,
        params: { licensePlate },
      },
    );
  }
  getParkingTransactionEVDto(): Observable<ParkingTransactionEVDto[]> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ParkingTransactionEVDto[]>(
      '/backoffice/GetParkingEVAll',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'GetParkingEVAll',
        headerOnly: false,
        token: token,
      },
    );
  }
  checkEvChargerStatus(body: EvDetailByIdPayload): Observable<any> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<any>(
      '/backoffice/CheckKwh',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'CheckKwh',
        token: token,
        headerOnly: false,
        params: {
          EvId: body.EvId,
        },
      },
    );
  }
  // -------------------- EV Edite ------------------------
  sentManualPlateCorrection(
    body: SendManualPlateCorrectionPayload,
  ): Observable<ApiResponseManualPlateCorrection> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ApiResponseManualPlateCorrection>(
      '/backoffice/SendManualPlateCorrection',
      'POST',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'SendManualPlateCorrection',
        headerOnly: false,
        token: token,
        body: body,
      },
    );
  }

  /* ------------------- EV QR ----------------------- */
  getGenerateEvQr(startDate: string, endDate: string) {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<GenerateEvQrResponse[]>(
      '/backoffice/GetGenerateEvQr',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'GetGenerateEvQr',
        token: token,
        headerOnly: false,
        // params: { start: startDate, end: endDate },
      },
    );
  }

  createGenerateEvQr(body: GenerateEvQrPayload): Observable<StatusAPIResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<StatusAPIResponse>(
      '/backoffice/CreateGenerateEvQr',
      'POST',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'CreateGenerateEvQr',
        token: token,
        headerOnly: false,
        body: body,
      },
    );
  }

  /* --------------------------------------------- Vehicle Master & Add -------------------------------------------- */

  sentAddVehicle(
    body: CityParkingUserVehiclePayload,
  ): Observable<ActionBackOfficeResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      '/backoffice/manageCityPaktingVehicle',
      'POST',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'ManageCityPaktingVehicle',
        token: token,
        headerOnly: false,
        body: body,
      },
    );
  }

  getVehiclelistresponse(uid: string): Observable<MyVehicleAllResponse[]> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<MyVehicleAllResponse[]>(
      '/backoffice/getVehiclelistresponse',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'GetVehicleListResponse',
        token: token,
        headerOnly: false,
        params: {
          uid: uid, // Assuming we filter by user ID
        },
      },
    );
  }

  getChargerHistoryById(evId: number): Observable<EvChargerHistory[]> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<EvChargerHistory[]>(
      '/backoffice/GetChargerHistoryById',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'GetChargerHistoryById',
        token: token,
        headerOnly: false,
        params: {
          evId: evId,
        },
      },
    );
    // const token = this.cookieService.get('token');
    // const headers = new HttpHeaders({
    //   Authorization: `Bearer ${token}`,
    //   'Content-Type': 'application/json',
    // });
    // const url = this.baseUrl + '/backoffice/GetChargerHistoryById';
    // const params = new HttpParams()
    // .set('evId', evId)

    // // console.log('Sent getCityParkingDiscountDetails : \n', headers , url , params.toString());
    // return this.http.get<EvChargerHistory[]>(url, {
    //   params,
    //   headers,
    // });
  }

  /* ------------------------------------------ Line OA -------------------------------------------- */
  getCityparkingUserLine(
    startDate?: string,
    endDate?: string,
  ): Observable<CityParkingUserLineResponse[]> {
    const token = this.cookieService.get('token');

    let params: any = {};
    if (startDate && endDate) {
      params = { startDate, endDate };
    }

    return this.apiMethodService.request<CityParkingUserLineResponse[]>(
      '/backoffice/getUserLineOA',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'GetUserLineOA',
        token: token,
        headerOnly: false,
        // params: params
      },
    );
  }

  getCityparkingDashboardUserLine(
    startDate?: string,
    endDate?: string,
  ): Observable<CityParkingUserLineResponse[]> {
    const token = this.cookieService.get('token');

    let params: any = {};
    if (startDate && endDate) {
      params = { startDate, endDate };
    }

    return this.apiMethodService.request<CityParkingUserLineResponse[]>(
      '/backoffice/getUserLineOA',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'GetUserLineOA',
        token: token,
        headerOnly: false,
        // params: params
      },
    );
  }

  // ---------------- Modal Line OA ---------------- //
  getCityParkingUserProfile(
    userId: number,
    uid: string,
  ): Observable<CityParkingUserInfomationResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<CityParkingUserInfomationResponse>(
      '/backoffice/getUserLineProfile',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'GetUserLineProfile',
        token: token,
        params: {
          uid: uid,
          cpUserId: userId,
        },
        headerOnly: false,
      },
    );
  }
  getVehicleMaster(): Observable<cityParkingVehicleMasterListResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<cityParkingVehicleMasterListResponse>(
      '/backoffice/getVehicleMaster',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'getVehicleMaster',
        token: token,
        headerOnly: false,
      },
    );
  }
  updateCityParkingUserProfile(
    body: CityParkingUserProfilePayload,
  ): Observable<ActionBackOfficeResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      '/backoffice/correctCityParkingUser',
      'POST',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'correctCityParkingUser',
        token: token,
        body: body,
        headerOnly: false,
      },
    );
  }
  deleteCityparkingUserVehicle(
    body: CityParkingUserVehicleDeletePayload,
  ): Observable<ActionBackOfficeResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      '/backoffice/delateCityPaktingVehicleById',
      'POST',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'deleteCityPaktingVehicleById',
        token: token,
        body: body,
        headerOnly: false,
      },
    );
  }

  sentManageCityparkingVehicle(
    body: CityParkingUserVehiclePayload,
  ): Observable<ActionBackOfficeResponse> {
    const token = this.cookieService.get('token');
    console.log("Citiparking vehicle payload : ", body);
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      '/backoffice/manageCityPaktingVehicle',
      'POST',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'manageCityPaktingVehicle',
        token: token,
        headerOnly: false,
        body: body,
      },
    );
  }
  /*------------------------------------------------------------------- Customer -------------------------------------------------------------------*/

  /*-------------------------------- Modal Customer --------------------------------*/



  disableCityParkingCustomer(
    body: CityParkingCustomerLineDeletePayload,
  ): Observable<ActionBackOfficeResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      '/backoffice/DisableCityParkingCustomer',
      'PATCH',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'DisableCityParkingCustomer',
        token: token,
        headerOnly: false,
        body: body,
      },
    );
  }

  /*----------------- Modal Customer Add -----------------*/
  getCityParkingCustomerLines(
    keyWord: string,
  ): Observable<CityParkingLineListForChooseResponse[]> {
    const token = this.cookieService.get('token');
    const params = {
      keyWord: keyWord,
    };
    return this.apiMethodService.request<
      CityParkingLineListForChooseResponse[]
    >('/backoffice/SearchCityParkingLineOaByKeyWord', 'GET', this.baseUrl, {
      isConsoleLog: false,
      labelLog: 'SearchCityParkingLineOaByKeyWord',
      token: token,
      headerOnly: false,
      params: params,
    });
  }

  AddLineMemberCustomer(
    body: AddLineMemberCustomerPayload,
  ): Observable<ActionBackOfficeResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      '/backoffice/AddLineMemberCustomer',
      'POST',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'AddLineMemberCustomer',
        token: token,
        headerOnly: false,
        body: body,
      },
    );
  }



  /* ----------------------------------------------------------- Register Parking ----------------------------------------------------------- */
  getRegisterParkingDetail(startDate: string, endDate: string) {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<CityParkingRegisterGroupResponse[]>(
      '/backoffice/GetCityParkingRegisterGroupAll', // Check endpoint path? User didn't specify, assumption.
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'GetCityParkingRegisterGroupAll',
        token: token,
        headerOnly: false,
        params: { startDate: startDate, endDate: endDate },
      },
    );
  }
  getDashboardDataParkingDetail(startDate: string, endDate: string) {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<CityParkingRegisterGroupResponse[]>(
      '/backoffice/GetCityParkingRegisterGroupAll', // Check endpoint path? User didn't specify, assumption.
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'GetCityParkingRegisterGroupAll',
        token: token,
        headerOnly: false,
        params: { startDate: startDate, endDate: endDate },
      },
    );
  }
  sentConfirmRegisterParking(
    body: CityParkingRegisterMemberGroupPayload,
  ): Observable<ActionBackOfficeResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      '/backoffice/register_parking', // Check endpoint path? User didn't specify, assumption.
      'POST',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'sentConfirmRegisterParking',
        token: token,
        headerOnly: false,
        body: body,
      },
    );
  }

  getCityParkingRegisterMemberGroupById(
    id: number,
  ): Observable<CityParkingRegisterGroupByIdResponse> {
    const token = this.cookieService.get('token');
    const param = { registerGroupId: id };
    return this.apiMethodService.request<CityParkingRegisterGroupByIdResponse>(
      `/backoffice/GetCityParkingRegisterGroupById`,
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'getCityParkingRegisterMemberGroupById',
        token: token,
        params: param,
        headerOnly: false,
      },
    );
  }

  confirmCityParkingRegisterMemberGroup(
    payload: ConfirmPaymentRegisterPayload,
  ): Observable<ActionBackOfficeResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      `/backoffice/ConfirmPaymentRegister`,
      'POST',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'ConfirmPaymentRegister',
        token: token,
        headerOnly: false,
        body: payload,
      },
    );
  }

  cancelCityParkingRegisterMemberGroup(
    payload: ConfirmPaymentRegisterPayload,
  ): Observable<ActionBackOfficeResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      `backoffice/updateRegisterStatus`,
      'POST',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'UpdateRegisterStatus',
        token: token,
        headerOnly: false,
        body: payload,
      },
    );
  }

  createPayment(body: any): Observable<ActionBackOfficeResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      '/backoffice/createPayment',
      'POST',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'createPayment',
        token: token,
        headerOnly: false,
        body: body,
      },
    );
  }

  /* ---------------- Modal Register Parking ---------------- */
  getCityparkingUserLineParking(customerId: string): Observable<any[]> {
    const token = this.cookieService.get('token');
    const params = {
      customerId: customerId,
    };

    return this.apiMethodService.request<any[]>(
      '/backoffice/CityParkingCustomerLineList',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'CityParkingCustomerLineList',
        token: token,
        params: params,
        headerOnly: false,
      },
    );
  }
  getCityParkingVehicleByLineIdApi(
    uid: string,
    siteId: number,
    vehicleTypeId: number,
  ): Observable<CityParkingVehicleLineResponse[]> {
    const token = this.cookieService.get('token');
    const params = {
      uid: uid,
      siteId: siteId,
      vehicleTypeId: vehicleTypeId,
    };

    return this.apiMethodService.request<CityParkingVehicleLineResponse[]>(
      '/backoffice/GetCityParkingVehicleByLineIdApi',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'GetCityParkingVehicleByLineIdApi',
        token: token,
        params: params,
        headerOnly: false,
      },
    );
  }

  getCityParkingVehiclesForRegisterNew(
    customerId: number,
    siteId: number,
    vehicleTypeId: number,
    uid?: string,
  ): Observable<CityParkingVehicleLineResponse[]> {
    const token = this.cookieService.get('token');
    const params: Record<string, string | number> = {
      customerId,
      siteId,
      vehicleTypeId,
    };
    if (uid) {
      params['uid'] = uid;
    }

    return this.apiMethodService.request<CityParkingVehicleLineResponse[]>(
      '/backoffice/GetCityParkingVehiclesForRegisterNew',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'GetCityParkingVehiclesForRegisterNew',
        token: token,
        params: params,
        headerOnly: false,
      },
    );
  }
  getParkingCardRegisterById(
    body: CityParkingCardRegisterPayload,
  ): Observable<ParkingCardRegisterResponse[]> {
    const token = this.cookieService.get('token');
    const params = {
      cpUserId: body.cpUserId,
      siteId: body.siteId,
      vehicleTypeId: body.vehicleTypeId,
    };

    return this.apiMethodService.request<ParkingCardRegisterResponse[]>(
      '/backoffice/GetParkingCardRegisterById',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'GetParkingCardRegisterById',
        token: token,
        params: params,
        headerOnly: false,
      },
    );
  }

  getRegisterRenewVehicles(
    customerId: number,
    siteId: number,
    vehicleTypeId: number,
    userId: number,
    clientId: number,
  ): Observable<RegisterRenewVehicleLineResponse[]> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<RegisterRenewVehicleLineResponse[]>(
      '/backoffice/GetRegisterRenewVehicles',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'GetRegisterRenewVehicles',
        token: token,
        params: { customerId, siteId, vehicleTypeId, userId, clientId },
        headerOnly: false,
      },
    );
  }

  getParkingFeeForMemberApi(
    siteId: number,
    vehicleTypeId: number,
  ): Observable<any[]> {
    const token = this.cookieService.get('token');
    const params = {
      SiteId: siteId,
      VehicleTypeId: vehicleTypeId,
    };

    return this.apiMethodService.request<any[]>(
      '/backoffice/GetParkingFeeForMemberApi',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'GetParkingFeeForMemberApi',
        token: token,
        params: params,
        headerOnly: false,
      },
    );
  }

  sentSaveCityparkingRegisterMemberGroup(
    body: CityParkingRegisterMemberGroupPayload,
  ): Observable<ActionBackOfficeResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      '/backoffice/RegisterMemberCardBackendNew',
      'POST',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'RegisterMemberCardBackendNew',
        token: token,
        headerOnly: false,
        body: body,
      },
    );
  }

  updateRegisterMemberGroupDraft(
    body: CityParkingRegisterMemberGroupPayload,
  ): Observable<ActionBackOfficeResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      '/backoffice/updateRegisterMemberGroupDraft',
      'PATCH',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'updateRegisterMemberGroupDraft',
        token: token,
        headerOnly: false,
        body: body,
      },
    );
  }

  /* ----------------------------------------------------------- Revenue ----------------------------------------------------------- */
  getGetFinanceManual(startDate: string, endDate: string) {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<FinanceInfoResponse[]>(
      '/backoffice/GetFinanceManual',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'GetFinanceManual',
        token: token,
        headerOnly: false,
        params: { start: startDate, end: endDate },
      },
    );
  }

  /* ---------------- Revenue Form ---------------- */

  sentSaveCityparkingRevenue(
    body: CreateTheFinancePayload,
  ): Observable<ActionBackOfficeResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      '/backoffice/CreateTheFinanceManual',
      'POST',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'CreateTheFinanceManual',
        token: token,
        headerOnly: false,
        body: body,
      },
    );
  }

  /* ------------------------------------------------------- Vehicle-list ------------------------------------------------------- */
  getCityParkingVehicleAll() {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<CityParkingVehicleAllResponse[]>(
      '/backoffice/GetCityParkingVehicleAll',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'GetCityParkingVehicleAll',
        token: token,
        headerOnly: false,
      },
    );
  }

  /* ----------------------------------------------------------- Invoice ----------------------------------------------------------- */
  getCityparkingInvoice(
    startDate?: string,
    endDate?: string,
  ): Observable<InvoiceHeader[]> {
    const token = this.cookieService.get('token');

    let params: any = {};
    if (startDate && endDate) {
      params = { startDate, endDate };
    }

    return this.apiMethodService.request<InvoiceHeader[]>(
      '/backoffice/GetCityParkingInvoiceList',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'GetCityParkingInvoiceList',
        token: token,
        headerOnly: false,
        params: params,
      },
    );
  }

  getCityParkingInvoiceById(id: number): Observable<InvoiceHeaderResponse> {
    const token = this.cookieService.get('token');
    console.log('getCityParkingInvoiceById : \n', id);
    return this.apiMethodService.request<InvoiceHeaderResponse>(
      '/backoffice/GetInvoiceHeaderById',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'GetInvoiceHeaderById',
        token: token,
        headerOnly: false,
        params: { id },
      },
    );
  }

  /**
   * ดึงไฟล์ PDF ใบกำกับภาษีแบบเต็มรูปจาก API
   * @param invoiceId ไอดีของใบแจ้งหนี้
   * @returns Observable ของ Blob ไฟล์ PDF
   */
  getInvoicePdf(invoiceId: number): Observable<Blob> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
    const url = `${this.baseUrl}/Reports/invoice/${invoiceId}/pdf`;
    return this.http.get(url, { headers, responseType: 'blob' });
  }

  /**
   * ดึงไฟล์ PDF รายงานรายละเอียดทะเบียนสมาชิก (เฉพาะ status = 2)
   * ใช้ arraybuffer เพื่อลดโอกาสที่ Download Manager (เช่น IDM) จะดักไฟล์แทนการแสดงใน modal
   * @param registerGroupId ไอดีกลุ่มลงทะเบียน
   */
  getRegisterParkingPdf(registerGroupId: number): Observable<Uint8Array> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      Accept: 'application/octet-stream, application/pdf, */*',
    });
    const url = `${this.baseUrl}/Reports/register-parking/${registerGroupId}/pdf`;
    return this.http
      .get(url, {
        headers,
        responseType: 'arraybuffer',
      })
      .pipe(map((buffer) => new Uint8Array(buffer)));
  }

  /* --------------------------- Modal Invoice --------------------------- */
  getInvoiceFeeList() {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<InvoiceFeeList[]>(
      '/backoffice/GetInvoiceFeeList',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'GetInvoiceFeeList',
        token: token,
        headerOnly: false,
      },
    );
  }
  createCityParkingInvoice(
    body: InvoicePayLoad,
  ): Observable<ActionBackOfficeResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      '/backoffice/CreateCityParkingInvoice',
      'POST',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'CreateCityParkingInvoice',
        token: token,
        headerOnly: false,
        body: body,
      },
    );
  }

  updateCityParkingInvoice(
    body: UpdateInvoiceDetailsPayload,
  ): Observable<ActionBackOfficeResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      '/backoffice/UpdateCityParkingInvoice',
      'PATCH',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'UpdateCityParkingInvoice',
        token: token,
        headerOnly: false,
        body: body,
      },
    );
  }

  cancelInvoice(
    body: CancelInvoicePayload,
  ): Observable<ActionBackOfficeResponse> {
    const token = this.cookieService.get('token');
    const params: Record<string, string | number> = {
      invoiceId: body.invoiceId,
      userId: body.userId,
      reason: body.reason,
    };
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      '/backoffice/CancelInvoice',
      'PATCH',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'CancelInvoice',
        token: token,
        headerOnly: false,
        params: params,
      },
    );
  }

  getInvoiceCancelRequestPdf(invoiceId: number): Observable<Blob> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    const url = `${this.baseUrl}/Reports/invoice/${invoiceId}/cancel-request/pdf`;
    return this.http.get(url, { headers, responseType: 'blob' });
  }

  /* ---------------------------------------------------------- Transaction Parking ---------------------------------------------------------- */
  getTransactionParking(startDate: string, endDate: string, userId: number) {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ParkingTransactionResponse[]>(
      '/backoffice/GetParkingTransactions',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'GetParkingTransactions',
        token: token,
        headerOnly: false,
        params: { startDate: startDate, endDate: endDate, userId: userId },
      },
    );
  }
  // --------------- Modal Edit License --------------
  patchCorrectLicense(
    body: PatchCorrectLicensePayload,
    transactionId: number,
  ): Observable<ActionBackOfficeResponse> {
    const token = this.cookieService.get('token');

    return this.apiMethodService.request<ActionBackOfficeResponse>(
      `/backoffice/ChangeLicenseTransaction/${transactionId}`,
      'PATCH',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'ChangeLicenseTransaction',
        token: token,
        headerOnly: false,
        body: body,
      },
    );
  }
  // --------------- Modal Closing parking --------------
  closingTransaction(
    body: ClosingTransaction,
    transactionId: number,
  ): Observable<ActionBackOfficeResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      `/backoffice/ClosingTransaction/${transactionId}`,
      'PATCH',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'ClosingTransaction',
        token: token,
        headerOnly: false,
        body: body,
      },
    );
  }

  /* --------------------------- Modal Transaction Parking Detail --------------------------- */
  getParkingTransactionDetail(
    seq: number,
    userId: number,
  ): Observable<ParkingTransactionDetailResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ParkingTransactionDetailResponse>(
      '/backoffice/GetParkingTransactionsBySeq',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'GetParkingTransactionsBySeq',
        token: token,
        headerOnly: false,
        params: { seq: seq, userId: userId },
      },
    );
  }

  getParkingCardInfo(id: number): Observable<ParkingCardInfoResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ParkingCardInfoResponse>(
      '/backoffice/GetParkingCardInfo',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'GetParkingCardInfo',
        token: token,
        headerOnly: false,
        params: { id: id },
      },
    );
  }
  /* ------ Gate ----- */
  getParkingGate(siteId: number): Observable<ParkingGateListResponse[]> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ParkingGateListResponse[]>(
      '/backoffice/GetParkingGate',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'GetParkingGate',
        token: token,
        headerOnly: false,
        params: { SiteId: siteId },
      },
    );
  }
  saveParkingTransaction(
    body: ParkingTransactionPayload,
  ): Observable<ActionBackOfficeResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      '/backoffice/SaveParkingTransaction',
      'POST',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'SaveParkingTransaction',
        token: token,
        headerOnly: false,
        body: body,
      },
    );
  }
  /* ---------------------------------------------------------- Parking Card ---------------------------------------------------------- */
  getParkingCards(
    userId: number,
    siteId: number,
    page: number,
    pageSize: number,
    searchField?: string,
    searchText?: string,
    status?: number,
  ) {
    const params: any = {
      UserId: userId,
      page,
      pageSize,
    };

    if (searchField && searchText) {
      params.searchField = searchField;
      params.searchText = searchText;
    }
    if (status !== undefined && status !== null && status !== 0) {
      params.cardMode = status;
    }
    if (siteId !== undefined && siteId !== null && siteId !== 0) {
      params.siteId = siteId;
    }

    const token = this.cookieService.get('token');
    return this.apiMethodService.request<CityParkingGroupInfo>(
      '/backoffice/GetParkingCards',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'GetParkingCards',
        token: token,
        headerOnly: false,
        params: params,
      },
    );
  }
  getParkingCardSummary(siteId: number): Observable<ParkingCardSummary> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ParkingCardSummary>(
      '/backoffice/GetParkingCardSummary',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'GetParkingCardSummary',
        token: token,
        headerOnly: false,
        params: { siteId: siteId },
      },
    );
  }
  getParkingCardById(id: number): Observable<ParkingCardInfoResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ParkingCardInfoResponse>(
      '/backoffice/GetParkingCardById',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'GetParkingCardById',
        token: token,
        headerOnly: false,
        params: { id: id },
      },
    );
  }

  // --------------------------------------------- Stamp ---------------------------------------------
  getParkingCardStamp(siteId: number): Observable<ParkingCardStamp[]> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ParkingCardStamp[]>(
      '/backoffice/GetParkingCardStamp',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'GetParkingCardStamp',
        token: token,
        headerOnly: false,
        params: { siteId: siteId },
      },
    );
  }
}
